export default {"src":"/_next/static/media/3speak.32f129d9.svg","height":116,"width":142,"blurWidth":0,"blurHeight":0};